import { Injectable, Injector } from '@angular/core';
import { EntityTypes } from '../../models/enums/EntityTypes';
import { CustomizableEntityService } from '../../services/http/clients/customizable-entity-service';
import { DepartmentService } from '../../services/http/clients/department.service';
import { ProductTypeService } from '../../services/http/clients/product-type.service';

@Injectable({
    providedIn: 'root'
})
export class EntityServiceFactory {
    constructor(private readonly injector: Injector) {}

    getService(entityTypeId: number): CustomizableEntityService | undefined {
        switch (entityTypeId) {
            case EntityTypes.Department:
                return this.injector.get(DepartmentService);
            case EntityTypes.ProductType:
                return this.injector.get(ProductTypeService);
            default:
                throw new Error('Unsupported entity type ID.');
        }
    }
}
